<template>
  <section>
    <b-modal
      :can-cancel="false"
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Login</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Email">
            <b-input type="email" v-model="email" placeholder="Your email" required></b-input>
          </b-field>

          <b-field label="Password">
            <b-input type="password" v-model="password" password-reveal placeholder="Your password" required></b-input>
          </b-field>
        </section>
        <footer class="modal-card-foot">
          <router-link to="/forgot">forgot password?</router-link>
          <button @click="login()" style="margin-left: 20px" class="button is-primary">Login</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        isComponentModalActive: true,
        email: "",
        password: ""
      };
    },
    methods: {
      login() {
        this.$store
          .dispatch("login", {
            email: this.email,
            password: this.password
          })
          .then(() => {
            this.$router.push("/admin");
          })
          .catch((e) => {
            this.$buefy.toast.open(e.message);
          });
      },
      forgot() {
        this.$store
          .dispatch("forgot", {
            email: this.email
          })
          .then(() => {
            this.$buefy.toast.open("Email has been sent to " + this.email);
          })
          .catch((e) => {
            this.$buefy.toast.open(e.message);
          });
      }
    }
  };
</script>
